var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',{attrs:{"placement":"topLeft","title":_vm.status.msg}},[_c('div',{class:_vm.status.class})])}
var staticRenderFns = []

export { render, staticRenderFns }